// stores/transactionConfirmModal.ts

import { TRANSACTION_TYPES } from "@/utils/constants";
import { defineStore } from "pinia";
import { ref } from "vue";

interface TransactionConfirmModalData {
  isOpen: boolean;
  transactionType?: TRANSACTION_TYPES;
  confirm?: () => void;
  reject?: () => void;
}

export const useTransactionConfirmModal = defineStore(
  "transactionConfirmModal",
  () => {
    const modalData = ref<TransactionConfirmModalData>({
      isOpen: false,
    });

    function setTransactionType(type: TRANSACTION_TYPES) {
      modalData.value.transactionType = type;
    }

    function clearData() {
      modalData.value = {
        isOpen: false,
      };
    }

    function openModal() {
      return new Promise<boolean>((resolve) => {
        modalData.value.isOpen = true;
        modalData.value.confirm = function () {
          modalData.value.isOpen = false;
          resolve(true);
        };
        modalData.value.reject = function () {
          modalData.value.isOpen = false;
          resolve(false);
        };
      });
    }

    return {
      modalData,
      clearData,
      openModal,
      setTransactionType,
    };
  }
);
